import React, { createContext, useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

import { AppContextProps } from "../../Context/AppContext";
import { Endpoints } from "../../Lib/endpoints";
import { NonPaginatedResponse } from "../../Lib/responses";

import { usePerformRequest } from "../../Lib/usePerformRequest";

import Navbar from "../../Components/Navbar";
import { TeacherProfileProps } from "../../Lib/types";
import Assessments from "../Assessments";
import CourseMaterials from "../CourseMaterials";
import Courses from "../Courses";
import OngoingLesson from "../OngoingLesson";
import Overview from "../Overview";
import Profile from "../Profile";
import SingleAssessment from "../SingleAssessment";
import SingleCourse from "../SingleCourse";
import "./styles.scss";
export const AppContext = createContext<AppContextProps | undefined>(undefined);

const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);
};

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  useScrollToTop();

  const {
    data: adminProfile,
    response: adminProfileResponse,
    reloadData: reloadAdminProfile,
    isLoading: isLoadingProfile,
  } = usePerformRequest<NonPaginatedResponse<TeacherProfileProps>>({
    method: Endpoints.GetTeacherProfile().method,
    route: Endpoints.GetTeacherProfile().route,
  });

  useEffect(() => {
    if (adminProfileResponse && adminProfileResponse.status) {
      if (adminProfileResponse.status !== 200) {
        navigate("/login");
      }
    }
  }, [isLoadingProfile, adminProfileResponse]);

  const LogoutTeacher = async () => {
    localStorage.removeItem("t");
    navigate("/login");
  };
  return (
    <AppContext.Provider
      value={{
        logout: LogoutTeacher,
        profile: adminProfile?.data,
        isLoadingProfile,
        reloadProfile: reloadAdminProfile,
      }}
    >
      <div className="dashboard-container">
        <Navbar />
        <Routes>
          <Route path="/" element={<Overview />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/course/:courseID" element={<SingleCourse />} />
          <Route
            path="/lesson/assessments/:lessonID"
            element={<Assessments />}
          />
          {/* <Route path="/ongoing/:lessonID" element={<SingleLessonLiveKit />} /> */}
          <Route path="/ongoing/:lessonID" element={<OngoingLesson />} />
          <Route
            path="/assessment/:assessmentID"
            element={<SingleAssessment />}
          />
          <Route
            path="/lesson/materials/:lessonID"
            element={<CourseMaterials />}
          />

          <Route path="/profile" element={<Profile />} />
        </Routes>
      </div>
    </AppContext.Provider>
  );
};
export default Dashboard;
